export function createRequestGuard() {
  const inFlight = new Map();

  return function guard(key, factory, { cached, soloSiFalta = false } = {}) {
    if (soloSiFalta && cached != null) return Promise.resolve(cached);
    const pending = inFlight.get(key);
    if (pending) return pending;
    const request = Promise.resolve(factory()).finally(() => {
      if (inFlight.get(key) === request) inFlight.delete(key);
    });
    inFlight.set(key, request);
    return request;
  };
}
